import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import format from 'date-fns/format';
import { postApi } from '../helpers/http';

export const requestInstalledInfoSearch = date => ({
  type: ActionTypes.REQUEST_INSTALLED_INFO_SEARCH,
  date
})

export const receiveInstalledInfoSearch = (params, json) => ({
  type: ActionTypes.RECEIVE_INSTALLED_INFO_SEARCH,
  date: params.date,
  items: json.data,
  receivedAt: Date.now()
})

export const requestInstalledInfoDetails = (params) => ({
  type: ActionTypes.REQUEST_INSTALLED_INFO_DETAIL,
  // pc_selected:params,
  data_details:[],
  lastTime: ''
})

export const receiveInstalledInfoDetails = (json) => ({
  type: ActionTypes.RECEIVE_INSTALLED_INFO_DETAIL,
  // details: json.data,
  data_details:json.data.detailData,
  lastTime:json.data.update_time?format(new Date(json.data.update_time), 'yyyy/MM/dd'):"",
})

const doFetchInstalledInfoSearch = params => async dispatch => {
  dispatch(requestInstalledInfoSearch(params.date));

  const data = {
        "process_type": "getDataSoftInstallList",
        "pc_name": params.pc_name,
        "user_name": params.user_name,
        "user_id": params.user_id,
        "mac_add": params.mac_add,
        "offset": params.offset,
        "limit": params.limit,
        "app_name" : params.app_name,
        "selected_app_name": params.selected_user_name,        
  };
  // console.log('fetch:', data);
  try {
    const json = await postApi(data);
    dispatch(receiveInstalledInfoSearch(params, json));
  } catch (error) {
    console.error('Error:', error);
  };
  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json.data);
  //   dispatch(receiveInstalledInfoSearch(params, json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

const doFetchInstalledInfoDetails = params => async dispatch => {
  dispatch(requestInstalledInfoDetails(params));
  const data = {
        "process_type": "getDataSoftListDetail",
        "pc_name": params.pc_name,
        "user_name": params.user_name,
        "mac_add": params.mac_add,
  };
  // console.log('fetch:', data);
  try {
    const json = await postApi(data);
    dispatch(receiveInstalledInfoDetails(json));
  } catch (error) {
    console.error('Error:', error);
  };
  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json.data);
  //   dispatch(receiveInstalledInfoDetails(json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchInstalledInfoSearch = params => (dispatch, getState) => {
  return dispatch(doFetchInstalledInfoSearch(params));
}

export const fetchInstalledInfoDetails = params => (dispatch, getState) => {
  return dispatch(doFetchInstalledInfoDetails(params));
}
